module.exports = __webpack_public_path__ + "static/john-41ccd0642e4bb77c2da043b52438e92b.jpg";